export default {
  title: "Nouvelles fonctionnalités",
  "title-with-count":
    "Grande mise à jour : nous venons de lancer 1 nouvelle fonctionnalité. | Grande mise à jour : nous venons de lancer {count} nouvelles fonctionnalités.",
  description: "Votre CRM solaire préféré vient d'être mis à jour !",
  "action-label": "En savoir plus",
  "dismiss-label": "Rejeter",
  "changelog-label": "Historique des versions",
}
